/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
/* eslint-disable object-curly-newline */
import React, { useEffect, useState } from 'react';
import { Collapse } from 'antd';
import './service.less';
import { CaretRightOutlined } from '@ant-design/icons';
import DOMPurify from 'dompurify';
import uploadCvService from '../../Services/uploadCvService';
import '../KUD home/home.less';
import '../ViewProject/slider.less';

const { Panel } = Collapse;

function ServiceList() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    getAllServices();
  }, []);

  const getAllServices = async () => {
    const response = await uploadCvService.listServices();
    setServices(response.data.service);
  };

  return (
    <div className="kud-centered" style={{ justifyContent: 'left', alignItems: 'start', textAlign: 'left' }}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', width: '100%' }}>
        <h2 style={{ color: 'white' }}>Services</h2>
      </div>
      <Collapse
        bordered
        defaultActiveKey={['1']}
        expandIcon={({ isActive }) => <CaretRightOutlined className="ant-collapse-arrow" rotate={isActive ? 90 : 0} />}
        ghost
        accordion
      >
        {services && services.map((service: any) => {
          const htmlPurify = DOMPurify.sanitize(service.description);
          return (
            <Panel header={service.name} key={service._id} className="site-collapse-custom-panel">
              <div dangerouslySetInnerHTML={{ __html: htmlPurify }} />
            </Panel>
          );
        })}
      </Collapse>
    </div>
  );
}

export default ServiceList;
